import { render, staticRenderFns } from "./MainSideBarMenu.vue?vue&type=template&id=62436fb9&scoped=true&"
import script from "./MainSideBarMenu.vue?vue&type=script&lang=js&"
export * from "./MainSideBarMenu.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62436fb9",
  null
  
)

export default component.exports